// Single source of truth for scope-change navigation.
//
// Changing scope via the picker (or the FinanceAI logo) ALWAYS navigates to
// that scope's dashboard route and resets the in-scope sub-selector to its
// aggregate. This is implemented here once, not per page, so every entry
// point behaves identically: from Diagnostics, from a single property's page,
// from anywhere, picking a scope lands on that scope's dashboard.

import { NAV_BY_SCOPE } from './navConfig';

// The dashboard route for a scope is the first nav entry (the Overview
// Dashboard link) declared for that scope. Overall is the fallback.
export function dashboardPathForScope(scope) {
  return NAV_BY_SCOPE[scope]?.[0]?.path || '/overall';
}

// Apply a scope (or in-scope entity) change from the picker, the logo, an
// entity/personal sub-selector, or a scope-card drill-in:
//   1. switch scope,
//   2. set the entity sub-selector (defaults to the aggregate 'all' => All
//      Entities / All Personal / All; pass `entity` to land on a specific
//      entity instead, e.g. a jurisdiction-card drill-down), and
//   3. navigate to that scope's dashboard.
//
// This is the ONLY place scope/entity changes are wired to navigation. Every
// change site (picker, logo, sub-selectors, drill-ins) calls this instead of
// hand-rolling the setSelectedScope/setSelectedEntity/navigate sequence, so
// they can't drift out of sync with each other.
//
// Navigation is unconditional and does not read the current location: it never
// stays on the current page. It is a normal push, so the browser back button
// still returns to the previous page in the previous scope (no history rewrite).
export function applyScopeChange(scope, { setSelectedScope, setSelectedEntity, navigate, entity = 'all' }) {
  setSelectedScope(scope);
  setSelectedEntity(entity);
  navigate(dashboardPathForScope(scope));
}
